export var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType || (SubdivisionType = {}));
export var RsvpStatus;
(function (RsvpStatus) {
    RsvpStatus["YES"] = "YES";
    RsvpStatus["NO"] = "NO";
    RsvpStatus["WAITING"] = "WAITING";
})(RsvpStatus || (RsvpStatus = {}));
export var RsvpFieldset;
(function (RsvpFieldset) {
    /** Include RSVP details including: `created`, `modified`, `firstName`, `lastName`, `status`, `totalGuests`, `guests`, and `annonymized`. */
    RsvpFieldset["DETAILS"] = "DETAILS";
    /** Include RSVP form. */
    RsvpFieldset["FORM"] = "FORM";
    /** Include RSVP email. */
    RsvpFieldset["CONTACT_DETAILS"] = "CONTACT_DETAILS";
})(RsvpFieldset || (RsvpFieldset = {}));
export var RsvpTag;
(function (RsvpTag) {
    /** Return only RSVPs of all guests that are fully checked-in. */
    RsvpTag["FULLY_CHECKED_IN"] = "FULLY_CHECKED_IN";
    /** Return only RSVPs of all guests that aren't fully checked-in. */
    RsvpTag["NOT_FULLY_CHECKED_IN"] = "NOT_FULLY_CHECKED_IN";
    /** Return only RSVPs of guests that are members. */
    RsvpTag["MEMBER"] = "MEMBER";
})(RsvpTag || (RsvpTag = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map